export default {
  ORIGIN_KEY: 'origin',
  DATES_KEY: 'dates',
  ROOM_CONFIGURATIONS_KEY: 'roomConfigurations',
  PACKAGE_ROOM_ID_KEY: 'packageRoomId',
  PACKAGE_PRICE_KEY: 'packagePrice',
  PACKAGE_BOARD_CODE_KEY: 'packageBoardCode',
};
